import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { Dashboard } from '@app/Dashboard/Dashboard';
import { WorkLog } from '@app/WorkLog';
import { Reports } from '@app/Reports';
import { NotFound } from '@app/NotFound/NotFound';
import { ErrorBoundary } from '@app/components/ErrorBoundary';
import { TachometerAltIcon, ClockIcon, ChartBarIcon } from '@patternfly/react-icons';

export interface IAppRoute {
  label?: string;
  icon?: React.ComponentType;
  element: React.ReactElement;
  exact?: boolean;
  path: string;
  title: string;
  routes?: undefined;
}

export interface IAppRouteGroup {
  label: string;
  routes: IAppRoute[];
}

export type AppRouteConfig = IAppRoute | IAppRouteGroup;

const routes: AppRouteConfig[] = [
  {
    element: <Dashboard />,
    exact: true,
    label: 'Dashboard',
    icon: TachometerAltIcon,
    path: '/',
    title: 'TRACKER | Dashboard',
  },
  {
    element: <WorkLog />,
    exact: true,
    label: 'Work log',
    icon: ClockIcon,
    path: '/worklog',
    title: 'TRACKER | Work log',
  },
  {
    element: <Reports />,
    exact: true,
    label: 'Reports',
    icon: ChartBarIcon,
    path: '/reports',
    title: 'TRACKER | Reports',
  },
];

const flattenedRoutes: IAppRoute[] = routes.reduce(
  (flattened, route) => [...flattened, ...(route.routes ? route.routes : [route])],
  [] as IAppRoute[],
);

const AppRoutes = (): React.ReactElement => (
  <ErrorBoundary>
    <Routes>
      {flattenedRoutes.map(({ path, element }, idx) => (
        <Route path={path} element={element} key={idx} />
      ))}
      <Route path="*" element={<NotFound />} />
    </Routes>
  </ErrorBoundary>
);

export { AppRoutes, routes };
